module.exports = __webpack_public_path__ + "static/media/network.6ea4e11b.svg";